import { type HTMLAttributes, memo, type PropsWithChildren } from 'react';

export type SearchRowProps = HTMLAttributes<HTMLDivElement>;

export const SearchRow = memo(({ children }: PropsWithChildren<SearchRowProps>) => {
  return <div className="m-0 box-border flex w-full items-center justify-between gap-2 p-0">{children}</div>;
});

SearchRow.displayName = 'SearchRow';
